import React from 'react';
import { AreaChart } from './AreaChart';

export function ChartsExample(): JSX.Element {
  const data = [
    {
      name: 'KW 1',
      week: 0,
      total: 0,
      allocation: 3000,
    },
    {
      name: 'KW 2',
      week: 500,
      total: 500,
      allocation: 3000,
    },
    {
      name: 'KW 3',
      week: 750,
      total: 1250,
      allocation: 3000,
    },
    {
      name: 'KW 4',
      week: 750,
      total: 2000,
      allocation: 3000,
    },
    {
      name: 'KW 5',
      week: 900,
      total: 2900,
      allocation: 3000,
    },
    {
      name: 'KW 6',
      week: 100,
      total: 3000,
      allocation: 3000,
    },
  ];
  return (
    <div>
      <AreaChart
        datasets={['allocation', 'total', 'week'].map((key) => ({
          title: key,
          values: data.map((e) => e[key]),
          color: {
            week: '#00edff',
            total: '#eb5757',
            alloction: '#bdbdbd',
          }[key],
        }))}
        labels={data.map((e) => e.name)}
      />
    </div>
  );
}
